import DropzoneContainer from "../../components/bonusUi/dropzone";

const Dropzone = () => {
  return <DropzoneContainer />;
};

export default Dropzone;
